// @todo перенести сюда код из main относящийся к dropdownmenu

export default function initDropdownMenu() {
    if (typeof $().accordionjs === "undefined") {
        return false;
    }

    $(".header-dropdown-menu .menu-block .accordion-menu-item").accordionjs({
        activeIndex: false,
        closeOther: false,
        slideSpeed: 300,
        beforeOpenSection: handleCms,
        beforeCloseSection: handleCms,
    })
}

function handleCms(section, event) {
    if (event === undefined) return;

    const isCms = $(event.target).parents(".cms-action-panel").length != 0;
    const isEmpty = $(event.currentTarget).parent().find(".acc_content").html().trim() === "";
    if (isCms || isEmpty) {
        // @note добавил на случай если csm-панель расположена на заголовке элемента
        // или контент пустой
        return false;
    }

    return true;
}